import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { ImmersiveOnboarding } from './immersive-onboarding';
const IMMERSIVE_ROOT = "immersive-onboarding-root";
export const initImmersiveOnboarding = () => {
  let immersiveRoot = document.getElementById(IMMERSIVE_ROOT);
  if (immersiveRoot) {
    document.dispatchEvent(new CustomEvent("onImmersiveOnboardingInit"));
    return;
  }
  const modalsNode = document.getElementById("modals");
  immersiveRoot = document.createElement("div");
  immersiveRoot.setAttribute("id", IMMERSIVE_ROOT);
  modalsNode === null || modalsNode === void 0 || modalsNode.appendChild(immersiveRoot);
  const root = createRoot(immersiveRoot);
  root.render(<ImmersiveOnboarding />);
};